module.exports = __webpack_public_path__ + "web-icons.3bfa567f9cea7825c910.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/web-icons/web-icons.svg?v=0.2.3
// module id = ../../../../../src/fonts/web-icons/web-icons.svg?v=0.2.3
// module chunks = 5